import { useNavigate } from "react-router-dom";

import DashboardLayout from "../../components/layout/DashboardLayout";

const ReportsPage = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="p-4 md:p-6">

        <div className="mb-6">
          <h1 className="text-2xl font-bold">
            Reports
          </h1>

          <p className="text-slate-500">
            View and generate weighing scale service and compliance reports
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">

          {/* =====================================================
              CALIBRATION CERTIFICATE REPORT
          ===================================================== */}

          <div
            onClick={() =>
              navigate("/reports/calibration-due")
            }
            className="
              bg-white
              border
              border-slate-200
              rounded-2xl
              p-6
              cursor-pointer
              hover:shadow-lg
              transition
            "
          >
            <div className="text-4xl mb-3">
              ⚖️
            </div>

            <h2 className="text-lg font-semibold">
              Calibration Certificate Report
            </h2>

            <p className="text-sm text-slate-500 mt-2">
              View calibration certificates and upcoming calibration due dates
              for customer weighing scales.
            </p>
          </div>


          {/* =====================================================
              WEIGHT TEST REPORT
          ===================================================== */}

          <div
            onClick={() =>
              navigate("/reports/weight-test-due")
            }
            className="
              bg-white
              border
              border-slate-200
              rounded-2xl
              p-6
              cursor-pointer
              hover:shadow-lg
              transition
            "
          >
            <div className="text-4xl mb-3">
               🧪
            </div>

            <h2 className="text-lg font-semibold">
              Weight Test Report
            </h2>

            <p className="text-sm text-slate-500 mt-2">
              View weight test records and upcoming test due dates
              for customer weighing scales.
            </p>
          </div>

        </div>

      </div>
    </DashboardLayout>
  );
};

export default ReportsPage;